module.exports = __webpack_public_path__ + "img/c-05.ec3ed053.jpg";